module.exports = __webpack_public_path__ + "img/acmedXSZS.7c0c09e7.png";